<template>
	<div class="flex items-center justify-between gap-4" v-if="lastPage > 0">
		<Menu as="div" class="relative inline-block text-left">
			<div v-if="showRows">
				<MenuButton class="flex items-center">
					<span class="text-xs">Rows: {{ numRows }}</span>
					<ChevronDownIcon class="w-4 h-4 ml-1 cursor-pointer stroke-2 text-neutral-900" />
				</MenuButton>
			</div>

			<transition
				enter-active-class="transition duration-100 ease-out"
				enter-from-class="transform scale-95 opacity-0"
				enter-to-class="transform scale-100 opacity-100"
				leave-active-class="transition duration-75 ease-in"
				leave-from-class="transform scale-100 opacity-100"
				leave-to-class="transform scale-95 opacity-0">
				<MenuItems
					class="absolute left-0 bottom-8 z-10 w-56 mt-2 origin-bottom-left bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
					<div class="py-4">

						<MenuItem v-for="option in options" :key="option">
							<a
								@click="changeRows(option)"
								:class="[
									option == numRows ? 'bg-gray-100 text-neutral-900 font-semibold' : 'text-gray-700',
									'block px-4 py-2 text-sm cursor-pointer',
								]"
								>{{ option }} Rows</a
							>
						</MenuItem>
					</div>
				</MenuItems>
			</transition>
		</Menu>
		<div class="flex items-center gap-4">
			<button type="button" :class="currentPage > 1 ? '' : 'opacity-25'">
				<ChevronLeftIcon class="w-4 h-4 cursor-pointer stroke-2 text-neutral-900" @click="previousPage()" />
			</button>
			<span class="text-xs">{{ currentPage }} of {{ lastPage }}</span>
			<button type="button" :class="currentPage === lastPage ? 'opacity-25' : ''">
				<ChevronRightIcon class="w-4 h-4 cursor-pointer stroke-2 text-neutral-900" @click="nextPage()" />
			</button>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { type PropType } from "vue";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { ChevronLeftIcon, ChevronRightIcon, ChevronDownIcon } from "@heroicons/vue/24/outline";

type Rows = "All" | "5 Rows" | "10 Rows" | "20 rows";

const emit = defineEmits(["update"]);

const options = ref<number[]>([5,10,20,50,100,200])

const props = defineProps({
	showRows: {
		type: Boolean,
		default: true,
	},
	numRows: {
		type: Number,
		defualt: 5,
	},
	currentPage: {
		type: Number,
		default: 1,
		required: true,
	},
	lastPage: {
		type: Number,
		default: 1,
		required: true,
	},
});

const pagination = ref<{rows: number, page: number}>({
    rows: props.numRows,
    page: props.currentPage || 1,
})

const nextPage = () => {
	if (props.lastPage === props.currentPage) {
		return false;
    }
    pagination.value.page = pagination.value.page + 1
    
	emit("update", pagination.value);
};

const previousPage = () => {
	if (props.currentPage <= 1) {
		return false;
    }

	pagination.value.page = pagination.value.page - 1
	emit("update", pagination.value);
};

const changeRows = (row: number): void => {
    pagination.value.rows = row;
    pagination.value.page = 1;
    emit("update", pagination.value);
};
</script>
